import type { ListWorkspacesParams } from '../api/client';

/**
 * Build list workspace params from raw form values.
 * Trims and omits empty strings so only non-empty filters are sent.
 */
export function buildListParams(
  teamId: string,
  q: string,
  stripeCustomerId: string
): ListWorkspacesParams {
  const params: ListWorkspacesParams = {};
  const t = teamId.trim();
  if (t) params.teamId = t;
  const qTrim = q.trim();
  if (qTrim) params.q = qTrim;
  const s = stripeCustomerId.trim();
  if (s) params.stripeCustomerId = s;
  return params;
}
